import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=029bf9f2&scoped=true"
import script from "./CloseIcon.vue?vue&type=script&lang=js"
export * from "./CloseIcon.vue?vue&type=script&lang=js"
import style0 from "./CloseIcon.vue?vue&type=style&index=0&id=029bf9f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029bf9f2",
  null
  
)

export default component.exports